import { EventEmitter, HostBinding, Output } from "@angular/core";
import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InlineEditComponent),
  multi: true,
};

@Component({
  selector: "app-inline-edit",
  templateUrl: "./inline-edit.component.html",
  styleUrls: ["./inline-edit.component.scss"],
  providers: [VALUE_ACCESSOR],
})
export class InlineEditComponent implements ControlValueAccessor {
  @Output() changeDataEvent = new EventEmitter<any>();
  @Input() required: boolean = true;
  @HostBinding("class.editing") editing: boolean = false;

  private _value: number;
  private preValue: number;
  public onChange: any = Function.prototype;
  public onTouched: any = Function.prototype;

  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  get value(): number {
    return this._value;
  }

  set value(newValue: number) {
    if (newValue && newValue !== this._value && newValue >= 1 && newValue <= 100) {
      this._value = newValue;
      this.onChange(newValue);
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  onSave(): void {
    this.editing = false;
    this.changeDataEvent.emit(this._value);
  }

  onCancel(): void {
    this.editing = false;
    this._value = this.preValue;
  }

  beginEdit(value: number): void {
    this.preValue = value;
    this.editing = true;
  }
}
